import ToolbarContainer from './ToolbarContainer';

export default ToolbarContainer;
